import { render, staticRenderFns } from "./ItemPickerDialog.vue?vue&type=template&id=06670c12&scoped=true"
import script from "./ItemPickerDialog.vue?vue&type=script&lang=js"
export * from "./ItemPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./ItemPickerDialog.vue?vue&type=style&index=0&id=06670c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06670c12",
  null
  
)

export default component.exports